import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CardAcceptorIdRoutes: Routes = [
  {
    path: "card-acceptor-id",
    loadComponent: () =>
      import("./card-acceptor-id/card-acceptor-id.component").then(
        (m) => m.CardAcceptorIdComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./card-acceptor-id-list/card-acceptor-id-list.component").then(
            (m) => m.CardAcceptorIdListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./card-acceptor-id-form/card-acceptor-id-form.component").then(
            (m) => m.CardAcceptorIdFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./card-acceptor-id-form/card-acceptor-id-form.component").then(
            (m) => m.CardAcceptorIdFormComponent,
          ),
      },
    ],
  },
];
